"use client";

import { usePathname, useSearchParams } from "next/navigation";
import Script from "next/script";
import { useEffect } from "react";

export function GoogleAnalytics({ gaId }: { gaId?: string | null }) {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const activeGaId = gaId || process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID;

    useEffect(() => {
        if (!activeGaId || typeof window.gtag !== "function") return;

        // Track pageview on route change
        window.gtag("config", activeGaId, {
            page_path: pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : ""),
        });
    }, [pathname, searchParams, activeGaId]);

    if (!activeGaId) return null;

    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${activeGaId}`}
            />
            <Script
                id="gtag-init"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${activeGaId}', {
              page_path: window.location.pathname,
            });
          `,
                }}
            />
        </>
    );
}
